/* istanbul ignore file */
import { useQuery } from '@tanstack/react-query';
import { api } from 'src/app/api/base';
import { URL_APPLICATION_INVENTORY_INFO } from 'src/app/api/urls';

export function useGetAppleApplicationInfo(deviceId: string, enabled = true) {
  return useQuery({
    queryKey: ['device-applications', deviceId, enabled],
    queryFn: async () => {
      return (
        await api(URL_APPLICATION_INVENTORY_INFO).get({
          computer_id: deviceId,
        })
      ).data;
    },
    enabled,
  });
}
